import { render, staticRenderFns } from "./AddResponsible.vue?vue&type=template&id=6566863a"
import script from "./AddResponsible.vue?vue&type=script&lang=js"
export * from "./AddResponsible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports